import { createAPIServiceNoCors } from './api.service';
import env from 'runtime.env';
export const SYNCHUB_ENDPOINT = type => `/${type}`;
export const ONEKEY_SYNCHUB_ENDPOINT = type => `/onekey/${type}`;
const service = createAPIServiceNoCors('pharmacy/search', {
  baseURL: env.RT_SYNCHUB,
});
const SEARCH_TYPE = '';

service.getPharmacies = async params => {
  const response = await service.get(SYNCHUB_ENDPOINT(SEARCH_TYPE), {
    params: params,
  });
  return response.data;
};

service.getOneKeyPharmacies = async params => {
  const response = await service.get(ONEKEY_SYNCHUB_ENDPOINT(SEARCH_TYPE), {
    params: params,
  });
  return response.data;
};
export default service;
